import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import EventCard from "@/components/EventCard";
import { MmaBouts, MmaHeader, useMmaCard } from "@/components/MmaCard";

function MmaUpcoming() {
  const card = useMmaCard("upcoming", true);
  if (card === undefined) return <div className="panel p-10 text-center text-slate-500">Loading fight card…</div>;
  if (!card) return <div className="panel p-10 text-center text-slate-500" data-testid="upcoming-empty">No upcoming UFC card on the schedule right now.</div>;
  return (
    <div className="panel p-5" data-testid="mma-upcoming">
      <MmaHeader card={card} />
      <MmaBouts card={card} />
    </div>
  );
}

const LEAGUES = [
  { key: "NFL", label: "NFL" },
  { key: "NBA", label: "NBA" },
  { key: "NCAAF", label: "COLLEGE FOOTBALL" },
  { key: "NCAAB", label: "COLLEGE BASKETBALL" },
  { key: "NHL", label: "NHL" },
  { key: "MLS", label: "MLS" },
  { key: "MMA", label: "MMA (UFC)" },
];
const PAGE = 9;

export default function UpcomingGames() {
  const [league, setLeague] = useState("NFL");
  const [data, setData] = useState({});
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    setShowAll(false);
    if (data[league] || league === "MMA") return;
    api.get("/upcoming", { params: { league } })
      .then((r) => setData((d) => ({ ...d, [league]: r.data.events || [] })))
      .catch(() => setData((d) => ({ ...d, [league]: [] })));
  }, [league, data]);

  const events = data[league];
  const shown = events ? (showAll ? events : events.slice(0, PAGE)) : [];
  return (
    <div data-testid="upcoming-games">
      <div className="flex flex-wrap gap-2 mb-5">
        {LEAGUES.map((l) => (
          <button key={l.key} onClick={() => setLeague(l.key)}
            className={`px-4 py-2 rounded-full text-xs font-black tracking-wide transition-colors ${league === l.key ? "btn-gold" : "btn-ghost-gold"}`}
            data-testid={`upcoming-tab-${l.key.toLowerCase()}`}>
            {l.label}
          </button>
        ))}
      </div>
      {league === "MMA" && <MmaUpcoming />}
      {league !== "MMA" && !events && <div className="panel p-10 text-center text-slate-500">Loading schedule…</div>}
      {league !== "MMA" && events && !events.length && (
        <div className="panel p-10 text-center text-slate-500" data-testid="upcoming-empty">No upcoming {league} games on the schedule right now.</div>
      )}
      {league !== "MMA" && shown.length > 0 && (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">{shown.map((e) => <EventCard key={e.id} event={e} />)}</div>
      )}
      {league !== "MMA" && events && events.length > PAGE && (
        <div className="text-center mt-6">
          <button onClick={() => setShowAll(!showAll)} className="btn-ghost-gold px-6 py-2.5 rounded-xl text-sm font-bold" data-testid="upcoming-show-all">
            {showAll ? "SHOW FEWER" : `SHOW ALL ${events.length} GAMES`}
          </button>
        </div>
      )}
    </div>
  );
}
